import type { NavSectionProps } from 'src/components/nav-section';

import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
};

// ----------------------------------------------------------------------
export const navData: NavSectionProps['data'] = [
  /**
   * Overview
   */
  {
    items: [
      {
        title: 'Support queue',
        path: paths.dashboard.support_queue,
        icon: ICONS.dashboard,
        deepMatch: true,
        testId: 'nav-support-queue',
      },
      {
        title: 'Employer data',
        path: paths.dashboard.employer_data.root,
        icon: ICONS.ecommerce,
        deepMatch: true,
        testId: 'nav-employer-data',
      },
      {
        title: 'Search',
        path: paths.dashboard.advanced_search,
        icon: <SearchTwoToneIcon fontSize="small" />,
        deepMatch: true,
        testId: 'nav-advanced-search',
      },
    ],
  },
];
